/*
  DAILE Premium Homepage JS
  Lightweight progressive enhancements only.
*/
(function () {
  if (window.__daileHomeLoaded) return;
  window.__daileHomeLoaded = true;

  // Помечаем документ как «JS активен» — reveal-CSS прячет элементы только при
  // наличии .daile-home-js (без JS контент не должен оставаться скрытым).
  // Имя уникальное (не голый .daile-js / .js) — чтобы не пересечься с чужими скриптами.
  document.documentElement.classList.add('daile-home-js');

  var prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Фоновые видео (геро + баннер кастома): при prefers-reduced-motion не проигрываем.
  if (prefersReduced) {
    document.querySelectorAll('.daile-home-hero__video, .daile-home-banner__media video').forEach(function (v) {
      v.removeAttribute('autoplay');
      try { v.pause(); } catch (e) {}
    });
  }

  var revealItems = document.querySelectorAll('.daile-reveal');

  if (!prefersReduced && 'IntersectionObserver' in window && revealItems.length) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.16 });

    revealItems.forEach(function (item) { observer.observe(item); });
  } else {
    revealItems.forEach(function (item) { item.classList.add('is-visible'); });
  }

  var sticky = document.querySelector('[data-daile-sticky-cta]');
  var footerCta = document.querySelector('.daile-final-cta');

  if (sticky && footerCta && 'IntersectionObserver' in window) {
    var stickyObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        sticky.style.opacity = entry.isIntersecting ? '0' : '1';
        sticky.style.pointerEvents = entry.isIntersecting ? 'none' : 'auto';
      });
    }, { threshold: 0.18 });

    stickyObserver.observe(footerCta);
  }

  // --- TASK73: страховка зацикливания hero-видео (мобайл) ---
  // Атрибут loop на iOS с внешним CDN иногда не срабатывает — по 'ended'
  // перематываем в начало и запускаем снова.
  document.querySelectorAll('.daile-home-hero__video, .daile-home-banner__media video').forEach(function (v) {
    if (prefersReduced) return;
    v.addEventListener('ended', function () {
      try { v.currentTime = 0; var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); } catch (e) {}
    });
  });

  // --- TASK68: фото-карусель героя (десктоп): каждые 2s кадр вперёд, бесконечно ---
  // «Крутится дальше, а не возвращается»: в конец добавлен КЛОН первого кадра —
  // после проезда на клон трек мгновенно (без анимации) встаёт на настоящий первый.
  var heroSlides = document.querySelector('[data-daile-hero-slides]');
  if (heroSlides && heroSlides.children.length > 1 && !prefersReduced) {
    var heroMq = window.matchMedia('(min-width: 1000px)');
    var heroCount = heroSlides.children.length;           // 5 настоящих
    heroSlides.appendChild(heroSlides.children[0].cloneNode(true)); // + клон первого
    var heroIdx = 0;
    var heroTimer = null;
    /* DAILE custom (RTL): в арабской версии слайды выкладываются справа налево,
       значит и лента должна ехать в плюс — иначе после последнего кадра пустота. */
    var heroDir = document.documentElement.getAttribute('dir') === 'rtl' ? 1 : -1;

    var heroReset = function () {
      heroSlides.style.transition = 'none';
      heroIdx = 0;
      heroSlides.style.transform = 'translateX(0)';
      void heroSlides.offsetWidth; // reflow: иначе следующий сдвиг не анимируется
    };
    var heroStep = function () {
      heroIdx++;
      // TASK69: плавнее — длинный мягкий ход (1.6s easeInOut) вместо резкого 0.8s
      heroSlides.style.transition = 'transform 1.6s cubic-bezier(0.65, 0, 0.35, 1)';
      heroSlides.style.transform = 'translateX(' + (heroDir * heroIdx * 100) + '%)';
      if (heroIdx === heroCount) { // доехали до клона → тихо перескочить на старт
        heroSlides.addEventListener('transitionend', heroReset, { once: true });
      }
    };
    var heroSync = function () {
      if (heroMq.matches) {
        // TASK69: кадр стоит ~2s + 1.6s плавного переезда
        if (!heroTimer) heroTimer = setInterval(heroStep, 3600);
      } else {
        clearInterval(heroTimer);
        heroTimer = null;
        heroReset();
      }
    };
    if (heroMq.addEventListener) { heroMq.addEventListener('change', heroSync); }
    else if (heroMq.addListener) { heroMq.addListener(heroSync); }
    heroSync();
  }

  // --- Ленты товаров: стрелки prev/next (прогрессивно; на мобайле — нативный свайп) ---
  document.querySelectorAll('[data-daile-row]').forEach(function (row) {
    var track = row.querySelector('[data-daile-track]');
    var prev = row.querySelector('[data-daile-prev]');
    var next = row.querySelector('[data-daile-next]');
    if (!track || !prev || !next) return;

    function step() {
      var card = track.querySelector('.daile-home-card');
      var gap = parseFloat(getComputedStyle(track).columnGap) || 20;
      var w = card ? card.getBoundingClientRect().width + gap : track.clientWidth * 0.8;
      return Math.max(w * 2, w); // прокрутка на ~2 карточки
    }
    function go(dir) {
      track.scrollBy({ left: dir * step(), behavior: prefersReduced ? 'auto' : 'smooth' });
    }
    function sync() {
      var max = track.scrollWidth - track.clientWidth - 2;
      var overflow = max > 4;
      prev.hidden = !overflow || track.scrollLeft <= 2;
      next.hidden = !overflow || track.scrollLeft >= max;
    }

    prev.addEventListener('click', function () { go(-1); });
    next.addEventListener('click', function () { go(1); });
    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  });
})();
